export {
  type XScalarActiveProxy,
  XScalarActiveProxySchema,
} from './x-scalar-active-proxy'
export {
  type Tab,
  type XScalarTabs,
  XScalarTabsSchema,
} from './x-scalar-tabs'
